/**
 * Run the event callback in non-blocking manner.
 */
export const runEventListener = (func, args) => {
    setTimeout(() => func(args), 0);
};
